import React from 'react';
import PropTypes from 'prop-types';
import StepV from './StepV';
import './StepperVertical.scss';


const propTypes={
    steps: PropTypes.array,
    activeStep: PropTypes.number,
};

export default class StepperVertical extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {

        const {steps, activeStep} = this.props;

       // console.log('active step', this.props.activeStep);

        return (
                <table className='table-v-steps'>
                    <tbody>
                    {this.props.steps.map((step, index) => (
                        <StepV
                            key={index}
                            nameComponent={step.nameComponent}
                            completeTitle={step.completeTitle}
                            index={index}
                            completed={index < this.props.activeStep}
                            isLast={index === steps.length - 1}
                            first={index === 0}
                            imgSrc={step.imgSrc}
                        />
                    ))}

                    </tbody>
                </table>
        )
    }
};

StepperVertical.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/StepperVertical/index.js